import React from 'react'; 
import Card from '../../components/card.component';
import {
  Col,
  Row,
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import notification from '../../components/notification.component';
import empresaFunction from '../configuracion/configuracion.function';


const Contrasena = () => {

  const { register, handleSubmit, reset, errors, watch } = useForm();
  const onSubmit = (data) => {
    empresaFunction.contrasena(data).then((respuesta) => {
      if (respuesta.cambio_contrasena) {
        notification.success();
        reset({
          password_current: '',
          new_password: '',
          confirm_new_password: '',
        });
      } else {
        notification.warning('La contraseña no fue cambiada.');
      }
    })
  }

  return (
    <Row className="mt-3">
      <Col>
        <Card>
          <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <div className="grupo-input">
                  <small>Contraseña actual</small>
                  <input type="text" className={`form-control input-border ${errors.password_current && "is-invalid"}`} name="password_current" ref={register({ required: true })} />
              </div>
            </Col>
            <Col>
              <div className="grupo-input">
                  <small>Nueva contraseña</small>
                  <input type="text" className={`form-control input-border ${errors.new_password && "is-invalid"}`} name="new_password" ref={register({ required: true })} />
              </div>
            </Col>
            <Col>
              <div className="grupo-input">
                  <small>Confirma la nueva contraseña</small>
                  <input type="text" className={`form-control input-border ${errors.confirm_new_password && "is-invalid"}`} name="confirm_new_password" ref={register({ required: true, validate: value => watch('new_password') === value })} />
              </div>
             </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-end mt-2">
                <button type="submit" className="btnx btnx-warn">Cambiar contraseña</button>
             </Col>
            </Row>
           </form>
        </Card>
      </Col>
   </Row>
  )
}

export default Contrasena;